import styled from 'styled-components';
import { BannerProps } from './Banner';

export const Container = styled.section<Pick<BannerProps, 'bgImage'>>`
	padding: 120px 0;
	background: url(${({ bgImage }) => bgImage}) center no-repeat;
	background-size: cover;

	@media (max-width: 768px) {
		padding: 60px 0;
	}
`;

export const Banner = styled.div`
	width: 56vw;
	margin: 0 auto;
	color: #fff;

	h2 {
		text-transform: uppercase;
		margin: 0;
		font-size: 2.4rem;
		text-align: center;
	}

	& > div {
		display: flex;
		justify-content: center;
		margin: 40px 0 0;

		img {
			width: 145px;
			height: 40px;
		}
	}

	p {
		margin: 80px 0 0;
		text-align: center;
		font-size: 1.4rem;

		a {
			text-decoration: underline;

			&:hover {
				opacity: 0.7;
			}
		}
	}

	@media (max-width: 768px) {
		width: unset;
		padding: 0 16px;

		h2 {
			font-size: 1.8rem;
		}

		p {
			margin: 60px 0 0;
			font-size: 1rem;
		}
	}
`;
